import { useMutation, useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/constants/queryKeys";
import { services } from "@/services/registry";
export const useChangelogsQuery = (limit, nextToken, distribution = "blast-c", enabled = true)=>{
    return useQuery({
        queryKey: queryKeys.changelogs.list(limit, nextToken, distribution),
        queryFn: ()=>services.changelogsService.getChangelogs(limit, nextToken, distribution),
        staleTime: 10 * 60 * 1000,
        enabled
    });
};
export const useChangelogQuery = (changelogId, distribution)=>{
    return useQuery({
        queryKey: queryKeys.changelogs.byId(changelogId, distribution),
        queryFn: ()=>services.changelogsService.getChangelog(changelogId, distribution),
        enabled: !!changelogId,
        staleTime: 10 * 60 * 1000
    });
};
export const useDownloadChangelog = ()=>{
    return useMutation({
        mutationFn: (changelog)=>services.changelogsService.getDownloadUrl(changelog.changelogId, changelog.distribution)
    });
};
export const useChangelogs = (limit, nextToken, distribution = "blast-c", enabled)=>{
    const query = useChangelogsQuery(limit, nextToken, distribution, enabled);
    return {
        changelogs: query.data?.changelogs || [],
        count: query.data?.count || 0,
        nextToken: query.data?.nextToken,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        error: query.error,
        refetch: query.refetch,
        formatFileSize: services.changelogsService.formatFileSize.bind(services.changelogsService),
        getChangeTypeLabel: services.changelogsService.getChangeTypeLabel.bind(services.changelogsService)
    };
};
